import { render, staticRenderFns } from "./PackageUomWarningDialog.vue?vue&type=template&id=328f0f6e&lang=pug&"
import script from "./PackageUomWarningDialog.vue?vue&type=script&lang=js&"
export * from "./PackageUomWarningDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports